import React, { Component } from 'react'
import { Map, List, fromJS } from 'immutable'
import { connect } from 'react-redux'
import { loadItem } from '../actions'
import { Table } from 'semantic-ui-react'
import Card, { CardList } from '~/common/card'

let { Header: TableHeader, HeaderCell, Body, Row, Cell } = Table

class OrganizationCardContainer extends Component {
  render() {
    let { organization = Map() } = this.props
    if (!Map.isMap(organization)) return 'No organization'

    let data = organization.get('data', Map())

    let items = [['Y-tunnus', organization.get('businessid', '')]]

    return (
      <Card title={organization.get('name', 'Organisaation nimi')} icon="building" classTag="organization">
        <CardList items={items.map(([label = '', value = '']) => ({ label, value }))} />
      </Card>
    )
  }
}

function mapStateToProps(state) {
  return {
    myState: state.myState,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    myAction: () => dispatch(myAction()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationCardContainer)
